var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fullyLoaded)?_c('Loading'):_c('SiteForm',{attrs:{"manufacturers":_vm.manufacturers,"submit":_vm.submit,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }